export default __webpack_public_path__ + "static/media/podium.9ecff047.webp";